import { CheckCircle2 } from 'lucide-react'
import React from 'react'

const CHAT_TURNS = [
  { role: 'user', text: 'vaga remoto java' },
  {
    role: 'ai',
    text: 'É pra Júnior, Pleno ou Sênior? (Salário ~7–15k pleno em BR)',
  },
  { role: 'user', text: 'pleno, prefiro startup' },
  {
    role: 'ai',
    text: 'Achei 47 vagas. Top 3 abaixo:',
    cards: [
      { title: 'Backend Java — Nubank', detail: 'Remoto · Pleno · R$ 10–13k' },
      { title: 'Java Engineer — Creditas', detail: 'Remoto · Pleno · R$ 9–12k' },
      { title: 'Dev Java — Loft', detail: 'Remoto/SP · Pleno · R$ 8–11k' },
    ],
  },
]

const BENEFITS = [
  'Não precisa marcar filtros manuais',
  'IA entende intenção complexa',
  'Resultados rankeados por aderência real',
]

export function AIDemoChat() {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden bg-gradient-to-b from-white via-slate-50/60 to-white dark:from-zinc-950 dark:via-slate-900/20 dark:to-zinc-950">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-16">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-violet-50 border border-violet-100 dark:bg-violet-950/30 dark:border-violet-900/50 px-3 py-1 text-[10px] md:text-xs font-semibold uppercase tracking-widest text-violet-600 dark:text-violet-300 mb-3 md:mb-4">
            Veja a IA em ação
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 tracking-tight text-slate-900 dark:text-white">
            Uma conversa, 47 vagas relevantes
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-base md:text-lg leading-relaxed">
            Sem checkboxes. Sem abas. Só diz o que quer.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-16 items-center max-w-5xl mx-auto">
          {/* Chat mockup */}
          <div
            className="rounded-2xl border border-gray-200/80 dark:border-white/10 bg-white dark:bg-slate-900 shadow-xl shadow-slate-200/60 dark:shadow-black/30 overflow-hidden"
            aria-label="Demonstração de conversa com IA"
          >
            {/* Window chrome */}
            <div className="flex items-center gap-1.5 px-4 py-3 bg-gray-50 dark:bg-slate-800 border-b border-gray-100 dark:border-white/5">
              <div className="w-3 h-3 rounded-full bg-red-400" aria-hidden="true" />
              <div className="w-3 h-3 rounded-full bg-yellow-400" aria-hidden="true" />
              <div className="w-3 h-3 rounded-full bg-green-400" aria-hidden="true" />
              <span className="ml-2 text-xs text-gray-400 dark:text-slate-500 font-medium">
                AcheiVagas IA
              </span>
            </div>

            {/* Chat bubbles */}
            <div className="p-4 md:p-5 space-y-3">
              {CHAT_TURNS.map((turn, i) => (
                <div
                  // biome-ignore lint/suspicious/noArrayIndexKey: lista estática mockup
                  key={`turn-${i}`}
                  className={`flex ${turn.role === 'user' ? 'justify-end' : 'justify-start'}`}
                >
                  <div
                    className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${
                      turn.role === 'user'
                        ? 'bg-gradient-to-br from-blue-600 to-violet-600 text-white rounded-br-sm'
                        : 'bg-gray-100 dark:bg-slate-800 text-gray-800 dark:text-gray-100 rounded-bl-sm'
                    }`}
                  >
                    <p>{turn.text}</p>
                    {turn.cards && (
                      <div className="mt-3 space-y-2">
                        {turn.cards.map((card) => (
                          <div
                            key={card.title}
                            className="rounded-xl bg-white dark:bg-slate-700 border border-gray-200 dark:border-white/10 px-3 py-2 shadow-sm"
                          >
                            <p className="text-xs font-semibold text-gray-800 dark:text-gray-100">
                              {card.title}
                            </p>
                            <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5">
                              {card.detail}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Explanation */}
          <div className="space-y-6">
            <h3 className="text-xl md:text-2xl font-bold text-slate-900 dark:text-white tracking-tight">
              Filtros inteligentes, não manuais
            </h3>
            <ul className="space-y-4" aria-label="Benefícios do motor de IA">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <CheckCircle2
                    className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5"
                    aria-hidden="true"
                  />
                  <span className="text-slate-700 dark:text-slate-300 text-sm md:text-base leading-relaxed">
                    {b}
                  </span>
                </li>
              ))}
            </ul>
            <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed border-l-2 border-blue-200 dark:border-blue-800 pl-4">
              Nosso motor de intenção faz perguntas cirúrgicas quando necessário, em vez de
              sobrecarregar você com filtros.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
